module.exports = __webpack_public_path__ + "static/media/logo-name-black.9b01fb48.svg";